import { MattersListView } from "@/components/features/matters/MattersListView";
import { GlobalNotAuthorized, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/matters/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasAnyPagePermission } = useUser();

  if (
    !hasAnyPagePermission([
      PAGE_PERMISSION_KEYS.mattersAll,
      PAGE_PERMISSION_KEYS.mattersMy,
    ])
  ) {
    return <GlobalNotAuthorized />;
  }
  return (
    <MattersListView
      defaultPageSize={25}
      topContent={
        <Text as="h1" variant="title" className="mb-6 shrink-0">
          All matters
        </Text>
      }
    />
  );
}
